var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguretaichi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.2677 27.8789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 27.8789,
    opacity: 0,
    width: 20.2677,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12604 5.12109C10.5206 5.12109 11.6807 3.97266 11.6807 2.56641C11.6807 1.16016 10.5206 0 9.12604 0C7.71979 0 6.55963 1.16016 6.55963 2.56641C6.55963 3.97266 7.71979 5.12109 9.12604 5.12109ZM1.21588 8.56641L5.02447 8.56641C5.20025 8.56641 5.3526 8.70703 5.32916 8.88281L4.96588 13.8281C4.83697 15.5977 5.86822 16.6992 7.36822 17.0039L12.2667 18.0352L13.3213 23.2852C13.462 24 14.1885 24.3398 14.7276 24.2344C15.3838 24.1055 15.8057 23.4609 15.6768 22.8047L14.4815 16.7695C14.3878 16.3008 13.9893 15.9727 13.544 15.8203L9.75885 14.6367L10.087 10.0664C10.1221 9.71484 10.4503 9.58594 10.7198 9.80859L12.5128 11.2969C12.7354 11.4727 12.9932 11.5781 13.2862 11.5781L18.7237 11.5781C19.3917 11.5781 19.919 11.0391 19.919 10.3711C19.919 9.70312 19.3917 9.17578 18.7237 9.17578L13.7198 9.17578L11.1065 6.99609C10.4503 6.45703 9.8526 6.15234 8.9151 6.15234L2.84479 6.15234L4.19244 1.67578C4.37994 1.03125 4.01666 0.351562 3.38385 0.164062C2.73932-0.0234375 2.04791 0.339844 1.86041 0.984375L0.0674424 7.00781C-0.166933 7.80469 0.208067 8.56641 1.21588 8.56641ZM6.31354 27.7734C6.88775 27.9492 7.6026 27.6914 7.82525 26.9766L9.61822 20.9883C9.6651 20.8242 9.67682 20.6484 9.67682 20.4609L9.67682 18.6445L7.14557 18.1055C7.08697 18.0938 7.0401 18.0938 6.99322 18.082L7.25104 20.4609L5.50494 26.2852C5.31744 26.9062 5.68072 27.5859 6.31354 27.7734Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguretaichi);
export default __webpack_public_path__ + "static/media/figure.taichi.5d546106fe1df6e35627c1dd7885b500.svg";
export { ForwardRef as ReactComponent };